import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { provideTranslateService } from '@ngx-translate/core'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { CoreModule } from './core/core.module'
import { registerLocaleData } from '@angular/common'
import localeAr from '@angular/common/locales/ar'
import localeEn from '@angular/common/locales/en'
registerLocaleData(localeAr)
registerLocaleData(localeEn)
import { MAT_DATE_LOCALE } from '@angular/material/core'
import { TitleStrategy } from '@angular/router'
import { TranslatedTitleStrategy } from './core/strategies/translated-title.strategy'
import { providePrimeNG } from 'primeng/config'
import { HemaPreset } from '../assets/theme/primeng-preset'

// Get the language from localStorage
export function getLocaleFromLocalStorage(): string {
  const lang = localStorage.getItem('lang')
  return lang ? lang : 'en'
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule
  ],
  providers: [
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '../assets/i18n/',
        suffix: '.json'
      })
    }),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: TitleStrategy, useClass: TranslatedTitleStrategy },
    providePrimeNG({
      theme: {
        preset: HemaPreset,
        options: {
          darkModeSelector: false,
          // Put PrimeNG styles in the lowest-priority CSS layer so existing
          // unlayered custom CSS (table ::ng-deep, Bootstrap) keeps winning —
          // themes the previously-unstyled components without regressing tables.
          cssLayer: {
            name: 'primeng',
            order: 'primeng'
          }
        }
      }
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
